import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as LightBulbIcon } from '../../icons/light-bulb.svg';
import { ReactComponent as XmarkIcon } from '../../icons/xmark.svg';

import './ThemeSuggestions.scss';

const ThemeSuggestions = ({ allThemes, currentThemes, onThemeClick, suggestedThemes }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);

  // Don't render if no themes are available or suggested
  if (!allThemes || allThemes.length === 0 || !suggestedThemes || suggestedThemes.length === 0) {
    return null;
  }

  // Filter out themes that are already added
  const themesToSuggest = suggestedThemes.filter((theme) => !currentThemes.includes(theme));

  if (themesToSuggest.length === 0) {
    return null;
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  if (!isExpanded) {
    // Collapsed view - just the lightbulb
    return (
      <div className="ThemeSuggestions collapsed">
        <button className="toggle" type="button" title={t('songForm.showThemeSuggestions')} onClick={toggleExpanded}>
          <span className="icon">
            <LightBulbIcon />
          </span>
        </button>
      </div>
    );
  }

  return (
    <div className="ThemeSuggestions">
      <div className="header">
        <div className="label">
          <span className="icon">
            <LightBulbIcon />
          </span>
          {t('songForm.themeSuggestion')}
        </div>
        <button
          className="close"
          type="button"
          title={t('songForm.hideSuggestions')}
          aria-label={t('songForm.hideSuggestions')}
          onClick={toggleExpanded}
        >
          <XmarkIcon />
        </button>
      </div>
      <div className="buttons">
        {themesToSuggest.map((theme) => (
          <button
            key={theme}
            className="theme-btn"
            type="button"
            title={t('songForm.addTheme', { theme })}
            onClick={() => onThemeClick(theme)}
          >
            {theme}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSuggestions;
